import INDIA_FLAG from "../../src/assets/images/flags/india.png"; // You'll need to add these flag images
import UAE_FLAG from "../../src/assets/images/flags/uae.png";
// Add more flag imports as needed

export const COUNTRY_CONFIG = [
  {
    code: "IN",
    name: "India",
    isdCode: "+91",
    flagImage: INDIA_FLAG,
    phoneLength: 10,
    maxLength: 10
  },
  {
    code: "AE",
    name: "UAE",
    isdCode: "+971",
    flagImage: UAE_FLAG,
    phoneLength: 9,
    maxLength: 9
  }
  //   {
  //     code: "US",
  //     name: "UAS",
  //     isdCode: "+1",
  //     flagImage: UAE_FLAG,
  //     phoneLength: 11,
  //     maxLength: 11
  //   }
  // Add more countries as needed
];

// Default country (India)
export const DEFAULT_COUNTRY = COUNTRY_CONFIG[0];
